import React, { FC, MouseEvent } from 'react';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import IconWithTextLockup from '../../../../lockups/IconWithTextLockup/IconWithTextLockup';
import { ReactSvg } from '../../../../shared/vector-images';
import BlueCircleWrapper from '../../../../shared/BlueCircleWrapper/BlueCircleWrapper';
import StyledNavListItem from '../StyledNavListItem/StyledNavListItem';

const SafetyGearListItem: FC<{
  heading: string;
  onClick: (
    e: MouseEvent<HTMLElement>,
    href: string,
  ) => Promise<boolean | undefined>;
  description?: string;
  icon: any;
  href: string;
}> = ({ onClick, icon, description, heading, href }) => {
  const theme = useTheme();
  const history = useHistory();

  const handleClick = async (e: MouseEvent<HTMLElement>) => {
    const shouldNavigate = await onClick(e, href);

    // If the beforeNavigate function returns an explicit "false", then don't navigate
    if (shouldNavigate === false) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    // Weird deckee shop link. I can't remember why it's like that. Allow the anchor to do it's thing
    if (href.indexOf('//') !== 0) {
      // Stop the browser navigating by default
      e.preventDefault();
      e.stopPropagation();
      history.push(href);
    }
  };

  return (
    <StyledNavListItem chevron href={href} onClick={handleClick}>
      <IconWithTextLockup
        image={
          <BlueCircleWrapper>
            <ReactSvg
              toDisplay={icon}
              options={{
                fillColor: theme.colors.secondary,
              }}
              width={24}
              height={24}
            />
          </BlueCircleWrapper>
        }
        heading={heading}
        description={description}
      />
    </StyledNavListItem>
  );
};

SafetyGearListItem.defaultProps = {
  description: undefined,
};

export default SafetyGearListItem;
